// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { Block } from "../ui/types/NewsTypes";
import { ValidatorResult } from "../ui/types/Types";
import i18n from "i18next";

export const validate = (blocks: Block[]): ValidatorResult => {
  if (blocks.length === 0) {
    return {
      validate: false,
      message: i18n.t("news.submit.error.no_block")
    };
  }
  for (let blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
    const block = blocks[blockIndex];
    for (let inputIndex = 0; inputIndex < block.inputs.length; inputIndex++) {
      const input = block.inputs[inputIndex];
      if (input.inputType === "text") {
        const text = input?.content
          ?.replace(/(<([^>]+)>)/gi, "")
          ?.replace(/&nbsp;/gi, "")
          ?.trim();
        if (!text || text.length === 0) {
          return {
            validate: false,
            message: i18n.t("news.submit.error.empty_text_in_block", {
              input: inputIndex + 1,
              block: blockIndex + 1
            })
          };
        }
      }
    }
  }
  return {
    validate: true,
    message: ""
  };
};
